import { render } from "./TheSearchImageOnTopPage.vue?vue&type=template&id=5604ccf3&scoped=true&ts=true"
import script from "./TheSearchImageOnTopPage.vue?vue&type=script&lang=ts"
export * from "./TheSearchImageOnTopPage.vue?vue&type=script&lang=ts"

import "./TheSearchImageOnTopPage.vue?vue&type=style&index=0&id=5604ccf3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5604ccf3"]])

export default __exports__